var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[(_vm.enabled && !_vm.muted) ?  '' : 'no-audio', _vm.id],attrs:{"id":_vm.id}},[(_vm.horizontal)?_c('div',{staticClass:"led-wrapper"},[_c('div',{staticClass:"led h-2"})]):_c('div',{staticClass:"led-wrapper w-full h-full bg-gray-200 flex items-end"},[_c('div',{staticClass:"led w-full vertical"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }